import styled from 'styled-components'
import { media } from 'sidecar-design-library'

export const StaticList = styled.div`
  transition: all 200ms;
  padding: 0 0 0 1.875rem;
  margin: 0;

  ${media.belowTablet`
      padding: 0 0 0 0.1875rem;
    `}
`
